import ProductBadge from 'components/gruenland/atoms/badge/ProductBadge';
import { useFormat } from 'helpers/hooks/useFormat';

const Promo: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <ProductBadge>
      {formatMessage({
        id: 'badges.promo',
        defaultMessage: 'Promo',
      })}
    </ProductBadge>
  );
};

export default Promo;
